import { gql } from "@apollo/client";

export const UPDATE_DRIVER = gql`
  mutation updateDriver($data: UpdateDriveInput!) {
    updateDriver(data: $data) {
      id
      name
      state
      latitude
      longitude
      is_deleted
    }
  }
`;

export const UPDATE_VEHICLE = gql`
  mutation updateVehicle($data: UpdateVehicleInput!) {
    updateVehicle(data: $data) {
      id
    }
  }
`;

export const ADD_CATEGORY_DRIVER = gql`
  mutation addCategory($data: CreateVehicleCategoryInput!) {
    addCategory(data: $data)
  }
`;

export const REMOVE_CATEGORY_DRIVER = gql`
  mutation removeCategory($data: DeleteVehicleCategoryInput!) {
    removeCategory(data: $data)
  }
`;

export default UPDATE_DRIVER;
